import { useState } from "react";
import { useAction } from "convex/react";
import { api } from "../../api";
import { useToast } from "@/hooks/use-toast";
import { toConvexId } from "@/types/convex";

interface UseDeleteUserResult {
  isDeleting: boolean;
  deleteUser: (userId: string) => Promise<boolean>;
}

export const useDeleteUser = (): UseDeleteUserResult => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { toast } = useToast();
  const deleteUserAction = useAction(api.users.delete.user);

  const deleteUser = async (userId: string): Promise<boolean> => {
    setIsDeleting(true);
    
    try {
      const convexUserId = toConvexId.user(userId);
      await deleteUserAction({ user: convexUserId });
      
      toast({
        title: "Success",
        description: "User deleted successfully.",
      });
      
      return true;
    } catch (error) {
      console.error("Failed to delete user:", error);
      toast({
        title: "Error",
        description: "Failed to delete user. Please try again.",
        variant: "destructive"
      });
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    isDeleting,
    deleteUser
  };
};